import { useThemeComponents } from '@/components/theme-preset-provider';

export function ThemedRootLayout() {
  const { Layout } = useThemeComponents();
  return <Layout />;
}
